module.exports = __webpack_public_path__ + "static/table-booking-app-cover-c2f891355366b490d707c8d4c4df7e65.png";